import { Timestamp } from '@framework/Timestamp';
import type { UserJSON } from 'balus-common';

export class UserEntity {
  constructor(
    readonly id: string,
    readonly name: string,
    readonly imageUrl: string | null,
    readonly createdAt: Timestamp,
    readonly updatedAt: Timestamp,
    readonly mailAddress: string,
    readonly hasPassword: boolean,
    readonly withInvitation: boolean | null,
    // メールアドレス自己変更フロー(EPIC-542)の申請中表示専用フィールド
    readonly pendingMailAddress: string | null = null,
    readonly pendingMailAddressRequestedAt: Timestamp | null = null
  ) {}

  dump(): UserJSON {
    const {
      id,
      name,
      imageUrl,
      createdAt,
      updatedAt,
      mailAddress,
      hasPassword,
      withInvitation,
      pendingMailAddress,
      pendingMailAddressRequestedAt,
    } = this;
    return {
      id,
      name,
      imageUrl: imageUrl ?? null,
      createdAt: createdAt.toISOString(),
      updatedAt: updatedAt.toISOString(),
      mailAddress,
      hasPassword,
      withInvitation,
      pendingMailAddress,
      pendingMailAddressRequestedAt: pendingMailAddressRequestedAt?.toISOString() ?? null,
    };
  }

  static load(dump: UserJSON): UserEntity {
    const {
      id,
      name,
      imageUrl,
      createdAt,
      updatedAt,
      mailAddress,
      hasPassword,
      withInvitation,
      pendingMailAddress,
      pendingMailAddressRequestedAt,
    } = dump;
    return new this(
      id,
      name,
      imageUrl ?? null,
      Timestamp.fromISOString(createdAt),
      Timestamp.fromISOString(updatedAt),
      mailAddress,
      hasPassword ?? false,
      withInvitation ?? null,
      pendingMailAddress ?? null,
      pendingMailAddressRequestedAt ? Timestamp.fromISOString(pendingMailAddressRequestedAt) : null
    );
  }

  static compare(a: UserEntity, b: UserEntity): number {
    return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
  }

  static compareById(a: UserEntity, b: UserEntity): number {
    return a.id.localeCompare(b.id);
  }

  match(text: string): boolean {
    return [this.id, this.name, this.mailAddress].some((value) => value.toLocaleLowerCase().includes(text));
  }

  isLeviiDomain(): boolean {
    // メールアドレスのドメインは大文字小文字を区別しない。mailAddress は入力されたままの表記で
    // 保存されている（小文字化されるのはログイン識別子のみ）ため、判定側で正規化する
    return this.mailAddress.toLowerCase().endsWith('@levii.co.jp');
  }

  static AdminConsoleUser = new UserEntity(
    'system-user',
    'Balusシステム管理者',
    'https://storage.googleapis.com/levii-balus-app-public-contents/noimage.png',
    new Timestamp('2024-01-01T00:00:00Z'),
    new Timestamp('2024-01-01T00:00:00Z'),
    'balus-support@levii.co.jp',
    false,
    false
  );
}
